module.exports = __webpack_public_path__ + "static/media/parts_2column.fdb09d74.svg";